<template>
    <div class="t-lk-modal__content _middle">
        <h2 class="t-lk-modal__title t-lk-requests-view__title">
            {{ props.manager ? $root.staticText.lk.requestsManager : $root.staticText.lk.contactsAxoft }}
        </h2>

        <div class="t-lk-requests-view-manager__wrap">
            <div v-if="props.manager" class="t-lk-requests-view-manager__img">
                <img v-if="props.managerImg" :src="props.managerImg" :alt="$root.staticText.lk.requestsManager">
            </div>
        </div>

        <div class="t-lk-requests-view__content">
            <div class="t-lk-requests-view__contact">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H8.28C8.48979 3.00016 8.69422 3.0663 8.86436 3.18905C9.03449 3.3118 9.1617 3.48496 9.228 3.684L10.726 8.177C10.8019 8.40534 10.7929 8.65339 10.7007 8.87564C10.6085 9.0979 10.4393 9.27945 10.224 9.387L7.967 10.517C9.07332 12.9655 11.0345 14.9267 13.483 16.033L14.613 13.776C14.7205 13.5607 14.9021 13.3915 15.1244 13.2993C15.3466 13.2071 15.5947 13.1981 15.823 13.274L20.316 14.772C20.5152 14.8383 20.6885 14.9657 20.8112 15.136C20.934 15.3064 21.0001 15.511 21 15.721V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H18C9.716 21 3 14.284 3 6V5Z" stroke="#C0C0CC" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="t-lk-requests-view__subtext">{{ $root.staticText.forms.phone }}</div>
                <a :href="'tel:' + props.phone" class="t-lk-requests-view__link">{{ props.phone }}</a>
            </div>
            <div class="t-lk-requests-view__contact">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z" stroke="#C0C0CC" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="t-lk-requests-view__subtext">{{ $root.staticText.forms.email }}</div>
                <a :href="'mailto:' + props.email" class="t-lk-requests-view__link">{{ props.email }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "request-contact",
        props: ['props'],
        data() {
            return {

            }
        },
        methods: {
            ...mapActions('modal', ['modalClose']),

        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/request-contact.vue